import React, {Component} from 'react';
import '../../asset/css/login.css';
import PageContentWallpaper from '../common/ef-pageContent';
import AddingModel from '../common/adding-model';

import {connect} from 'react-redux'
import {GetUserToken, PostToBackend} from "../../api/services";
import eConfig from '../../config';
import moment from "moment";

class SettingDealerComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ref: "",
            email: "",
            CurrentWallet: null,
            AgentWallet: [],
            Wallets: [],
            Agents: [],
            AgentsMap: {},
            Info: {},
            user: null,
            Role: "",
            modeTransfer: false,
            selectedTransfer: null,
            rechargeAmount: 0,
            rechargeNumber:"",

            dateContext:moment(),
            today:moment(),
        }

    }

    dashDates=()=>{
        const dateContext = this.state.dateContext;
        let firstDateOfWeek="",lastDateOfWeek="",firstDateOfMonth="",lastDateOfMonth="",currentDate="";


        currentDate = moment().format('YYYY-MM-DD');
        firstDateOfMonth = moment(dateContext).startOf('month').format('YYYY-MM-DD');
        lastDateOfMonth = moment(dateContext).endOf('month').format('YYYY-MM-DD');
        firstDateOfWeek = moment(dateContext).startOf('week').format('YYYY-MM-DD');
        lastDateOfWeek = moment(dateContext).endOf('week').format('YYYY-MM-DD');


        alert("firstDateOfWeek="+firstDateOfWeek+
        "\nlastDateOfWeek="+lastDateOfWeek+
            "\nlastDateOfWeek="+lastDateOfWeek+
            "\nfirstDateOfMonth="+firstDateOfMonth+
            "\nlastDateOfMonth="+lastDateOfMonth+
            "\ncurrentDate="+currentDate)
    }

    async componentDidMount() {
        this.dashDates();
        await this.isSupperUser()
        await this.fetchWallet();
        await this.fetchInfoAgent();
        await this.fetchInfoDealer();
        await this.fetchAgents();

    }

    isSupperUser = async () => {
        let user = GetUserToken();
        let tmp = this.state;
        tmp.user = user;
        tmp.email = user.Username;
        this.setState(tmp);
    }
    fetchWallet = async () => {
        let _this = this;
        let conds = [];
        this.fetchingAll("wallet", conds, (data) => {
            console.log("fetchWallet :> ", data);
            _this.setState({
                Wallets: data,
            });
        });
    }
    fetchAgents = async () => {
        let _this = this;
        let conds = [];
        this.fetchingAll("agent", conds, (data) => {
            console.log("fetchAgents :> ", data);
            let ls = [];
            let lsMap = {};
            for (let i in data) {
                const row = data[i];
                //console.log("+++++++++++>> ",row.dealer," == ",_this.state.ref);
                //if(row.dealer ===_this.state.ref){
                ls.push(row);
                lsMap[row.ref] = row;
                //}
            }
            _this.setState({
                Agents: ls,
                AgentsMap: lsMap
            });
        });
    }
    fetchInfoAgent = async () => {
        let _this = this;
        let endpoint = "/api/macro-finance/info/agent";
        const hub = {
            KeySearch: this.state.user.Username
        }
        let backend = eConfig.mainBackend;
        console.log("fetchInfoAgent send > ", hub);
        await PostToBackend(hub, backend, endpoint, function (dataIn, err) {
            console.log("fetchInfoAgent response > ", dataIn);
            if (typeof dataIn.RESULT !== "undefined") {
                const data = dataIn.RESULT;
                if (data.Dealer.Ref !== "") {
                    _this.setState({
                        Info: data,
                        ref: data.Dealer.Ref,
                        CurrentWallet: data.Wallet,
                        Role: "agent"
                    })
                }
            }
        });
    }
    fetchInfoDealer = async () => {
        console.log("fetchInfoDealer state > ", this.state.user);
        let _this = this;
        let endpoint = "/api/macro-finance/info/dealer";
        const hub = {
            KeySearch: this.state.user.Username
        }
        let backend = eConfig.mainBackend;
        console.log("fetchInfoDealer send > ", hub);
        await PostToBackend(hub, backend, endpoint, function (dataIn, err) {
            console.log("fetchInfoDealer response > ", dataIn);
            if (typeof dataIn.RESULT !== "undefined") {
                const data = dataIn.RESULT;
                if (data.Dealer.Ref !== "") {
                    _this.setState({
                        Info: data,
                        ref: data.Dealer.Ref,
                        CurrentWallet: data.Wallet,
                        Role: "dealer"
                    })
                }

            }
        });
    }
    fetchingAll = async (table, conds, callback) => {

        const user = GetUserToken();
        console.log("User :> ", user);

        let hub = {
            Fields: [],
            DbName: "chela",
            TableName: table,
            Conditions: conds,
        }
        //  /backend-ecare/api/global-service
        let backend = eConfig.mainBackend;
        let endpoint = "/api/global-service/list";

        console.log("fetchingAll send > ", table, hub);
        await PostToBackend(hub, backend, endpoint, function (dataIn, err) {
            console.log("fetchingAll response > ", table, dataIn);

            if (typeof dataIn.RESULT !== "undefined") {
                const data = dataIn.RESULT;
                callback(data);

            }
        });
    }


    getYourCurrentWalletBalance = () => {
        if (this.state.user === null) {
            return 0
        }
        if (this.state.CurrentWallet === null) {
            return 0
        }

        return this.state.CurrentWallet.Amount;
    }


    submitRecharge = async () => {
        let _this = this;
        const state = this.state;
        const saleAmount = parseFloat(state.rechargeAmount);
        if(this.getYourCurrentWalletBalance() < saleAmount ){
            alert("Sorry your balance is low! please recharge");
            return
        }
        let hub = {
            Vendor:"0871112223",
            Agent: this.state.CurrentWallet.AccountRef,
            AccountType:this.state.CurrentWallet.AccountType,
            Dealer: this.state.ref,
            RechargeNumber: this.state.rechargeNumber.ref,
            SaleAmount: parseFloat(this.state.rechargeAmount),
        }

        /*
        hub.Vendor ="0871112223"
	hub.Agent ="0676865372"
	hub.SaleAmount = 110
	hub.Dealer ="0729139504"
	hub.AccountType = "agent"
         */

        let backend = eConfig.mainBackend;
        let endpoint = "/api/macro-finance/manage/sale/pinless/new";

        console.log("submitRecharge send > ", hub);
        await PostToBackend(hub, backend, endpoint, function (dataIn) {
            console.log("submitRecharge response > ", dataIn);
            alert("Thank you,Transfer success!");
            _this.setState({
                rechargeAmount: 0,
                rechargeNumber:"",
            });

            _this.fetchWallet();
        });

    }

    handleInput = (e,key) => {
        let tmp = this.state;
        tmp[key] = e.target.value;
        this.setState(tmp);
    }
    getStateValue=(key)=>{
        return this.state[key];
    }


    render() {

        return (


            <PageContentWallpaper {...this.props} >


                <div>
                    <div className="row container">
                        <div className="col-xs-12">
                            <h2>
                                Your Current Wallet
                                <span className={"pull-right"}>
                                        Balance:&nbsp;&nbsp;
                                    <b style={{
                                        color: "red",
                                        fontSize: 24
                                    }}>{"R " + this.getYourCurrentWalletBalance()}</b>
                                    </span>
                            </h2>
                        </div>
                    </div>
                </div>


                <div className="row container">
                    <div className="col-xs-12">
                        <p className={"alert alert-info"} style={{fontSise: 16, fontWeight: "bold"}}>Sale</p>
                        <form onSubmit={this.submitRecharge}>
                            <div className="form-group">
                                <label htmlFor="exampleInputEmail1">Recharge phone number</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    aria-describedby="emailHelp"
                                    placeholder="Enter phone number..."
                                    onChange={(e)=>this.handleInput(e,"rechargeNumber")}
                                    value={this.getStateValue("rechargeNumber")}
                                />
                                <small id="emailHelp" className="form-text text-muted">
                                    Your number need to be in 10 digit e.g. 0729139504
                                </small>
                            </div>

                            <div className="form-group">
                                <label htmlFor="exampleInputEmail1">Recharge Amount</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    aria-describedby="emailHelp"
                                    placeholder="Enter Recharge Amount..."
                                    onChange={(e)=>this.handleInput(e,"rechargeAmount")}
                                    value={this.getStateValue("rechargeAmount")}
                                />
                                <small id="emailHelp" className="form-text text-muted">
                                    Your amount must be less then your balance
                                </small>
                            </div>
                            <div className="form-group">
                                <button className={"btn btn-primary pull-right"} type={"submit"}>
                                    Submit
                                </button>
                            </div>


                        </form>

                    </div>
                </div>

            </PageContentWallpaper>
        )


    }

}

const mapDispatchToProps = dispatch => ({
    dispatch: dispatch
})

const mapStateToProps = state => ({
    addingModel: state.addingModel,
    login: state.login
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(SettingDealerComponent)